import { useState } from "react"
import { Flex, Select, Button, Tooltip } from "antd"
import { PlusOutlined, DeleteOutlined, UpOutlined, DownOutlined  } from "@ant-design/icons"
import ConditionValue from "../../form-editor/conditionManager/ConditionValue"
import UserRoleDropdown from "../../UserRoleDropdown"
import { useTranslation } from 'react-i18next';

const ScenarioContainer = ({ 
    data, scenario, scenarioIndex, operators, getComparators, getFormType, deleteScenario, deleteCondition, addCondition, handleScenarioChange, handleScenarioAction, handleApproverSelection, scenarioFields }) => {
    const { t } = useTranslation();
    const [expandConditions, setExpandConditions] = useState(true)

    return (
        <div className='scenario-block'>
            <div className='scenario-header'>
                <div className='text-color-primary text-weight-500'>{t('Set the scenario')}</div>
                {
                    expandConditions ? <UpOutlined className='text-color-primary' onClick={() => setExpandConditions(false)} /> : <DownOutlined className='text-color-primary' onClick={() => setExpandConditions(true)} />
                }
            </div>
            {
                expandConditions ? 
                <>
                    <div className='action-block' key={"scenario-" + scenarioIndex} style={{backgroundColor: scenario.conditions?.length > 1 ? "#F7F7F8" : "#FFF", padding: scenario.conditions?.length > 1 ? "0.5rem" : "0"}}>
                        {
                            data.scenarios.length > 1 &&
                            <div className='scenario-delete'>
                                <DeleteOutlined style={{ color: "grey" }} onClick={() => deleteScenario(scenarioIndex)} />
                            </div>
                        }
                        {
                            scenario.conditions.map((condition, conditionIndex) => {
                                return (
                                    <Flex gap={8} align='center' justify='flex-start' key={"condition-" + condition.conditionId} style={{ marginBottom: "0.5rem" }}>
                                        {
                                            scenario.conditions.length > 1 && conditionIndex === 0 && <Select placeholder={t('Select field')} options={operators} value={scenario?.operator} onChange={(val) => handleScenarioChange('operator', val, scenarioIndex)} style={{ minWidth: "4.5rem", maxWidth: "4.5rem" }} />
                                        }
                                        <Select placeholder={t('Select field')} options={scenarioFields.map(field => {
                                            return { label: <Tooltip title={field.label}>{field.label}</Tooltip>, value: field.value }
                                        })} value={condition?.reference || undefined} onChange={(val) => handleScenarioChange('reference', val, scenarioIndex, conditionIndex)} style={{ minWidth: "10rem", maxWidth: "10rem" }} />
                                        {
                                            condition.reference ?
                                                <>
                                                    <Select placeholder={t('Comparator')} options={getComparators(condition.reference)} value={condition.comparator || undefined} onChange={(val) => handleScenarioChange('comparator', val, scenarioIndex, conditionIndex)} style={{ minWidth: "8.5rem", maxWidth: "8.5rem", textAlign: "left" }} />
                                                    <ConditionValue selectedElement={getFormType(condition.reference)} condition={condition} scenarioIndex={scenarioIndex} conditionIndex={conditionIndex} handleScenarioChange={handleScenarioChange} />
                                                </>
                                                : null
                                        }
                                        {scenario.conditions.length > 1 && <DeleteOutlined className='text-color-secondary cursor-pointer' onClick={() => deleteCondition(scenarioIndex, conditionIndex)} />}

                                    </Flex>
                                )
                            })
                        }
                        <div>
                            <Button className="condition-button" icon={<PlusOutlined />} onClick={() => addCondition(scenarioIndex)} style={{ padding: "0" }}>{t('Add Condition')}</Button>
                        </div>
                    </div>
                    {
                        scenario.conditions?.[0]?.["reference"] && 
                        <Flex gap={8} align='center' justify='flex-start' style={{ marginTop: "16px" }}>
                            <Select placeholder={t('Select action')} options={[{ label: t('Approver'), value: 'approver' }]} onChange={(val) => handleScenarioAction(scenarioIndex, 'action', val)} value={scenario.action || undefined} style={{ minWidth: "10rem", maxWidth: "10rem" }} />
                            <div style={{ maxWidth: "17.5rem", width: "17.5rem" }}>
                                <UserRoleDropdown tabsRequired={['user','group', 'userPicker']} onSelect={(values) => handleApproverSelection(scenarioIndex, 'approvers', values)} selectedOptions={scenario.approvers} getSpaceUsers={true} />

                            </div>
                        </Flex>
                    }
                </>
                : null
            }
        </div>
    )
}

export default ScenarioContainer